import get from 'lodash/get';
import { converter } from 'helpers/converter';
import { store } from '../store';

class RequestManager {
  /**
   * [addRequest send request]
   * @type AbstractRequestTask request
   * @return Promise
   */
  // TODO: CHECK HKS param
  static addRequest(request) {
    const params = request.getParams();
    const url = request.getUrl();
    if (typeof params.api_version !== 'undefined') {
      if (params.region == null) {
        params.region = window.utils.userType.checkRegion();
      }
    }

    const data = request.getParams();
    if (data.isCacheable) {
      delete data.HKS;
      delete data.user_hash;
    }

    delete data.isCacheable;

    const xhr = $.ajax({
      url: request.getUrl(),
      type: request.getMethod(),
      data: request.getParams(),
      withCredentials: true,
      crossDomain: true,
      headers: request.getHeaders(),
    });

    /* eslint no-extend-native: 0 */
    Promise.prototype.abort = () => {
      xhr.abort();
    };

    /* eslint no-console: 0 */
    // XMLHttpRequest.prototype.abort = (...args) => console.warn('ABORT', args);

    return new Promise((resolve, reject) =>
      xhr
        .done(request.success.bind({ request, resolve, reject }))
        .fail(request.error.bind({ request, resolve, reject })),
    ).catch((error, ...args) => {
      // NO CONTROLED ERROR
      if (request.passErrorToRequest) {
        return Promise.reject(error, ...args);
      }
      if (
        (!error ||
          (!error.message && !error.errors) ||
          (error.completeError &&
            error.completeError.status &&
            error.completeError.status !== 0 &&
            error.completeError.status !== 1 &&
            error.completeError.status !== 200)) &&
        !(
          error.completeError &&
          error.completeError.response &&
          error.completeError.response.userDetectWS &&
          error.completeError.response.userDetectWS.ip
        )
      ) {
        let canIShowModal = false;

        if (
          url.indexOf('/services/payway/') > -1 ||
          url.indexOf('/services/user/register') > -1 ||
          url.indexOf('/services/user/landing') > -1 ||
          url.indexOf('/services/user/net/') > -1
        ) {
          if (
            url.indexOf('/services/payway/purchasebuttoninfo') > -1 === false &&
            url.indexOf('/services/payway/renthistory') > -1 === false &&
            url.indexOf('/services/payway/listpaymentmethod') > -1 === false
          ) {
            canIShowModal = true;
          }
        }

        if (canIShowModal) {
          if (!(url.indexOf('telmexmexicogate') !== -1)) {
            let msg = '';
            const translations = window.utils.getMeta.translations;
            const code = error
            ? get(error, 'completeError.errors[0].code',
              get(error, 'completeError.errors.code', false),
            )
            : false;

            if (code && typeof translations === 'function')
              msg = translations(code, error.message);
            else msg = error.message;

            store.dispatch({
              type: 'ERROR_NOT_CONTROLED',
              payload: msg,
            });
          }
          return Promise.reject(error, ...args);
        }
        if (
          (error &&
            error.completeError &&
            error.completeError.errors &&
            error.completeError.errors.code &&
            error.completeError.errors.code === 'accept_terms') ||
          url.indexOf('services/user/sendpasswordreminder') > -1
        ) {
          return Promise.resolve(error);
        }
        return Promise.resolve({ response: {} });
      }
      return Promise.reject(error, ...args);
    });
  }
}

export default RequestManager;
